module.exports = __webpack_public_path__ + "img/goSetimg1.fe7d5e38.png";